export function checkSessionStatus({ isCanceled = false, enrollments = [] }) {
  return {
    isCanceled: isCanceled,
    isPaid: enrollments.some(e => e.transactions?.some(t => !t.refund)),
    isLessonCredit: enrollments.some(e => e.lessonCredit),
  }
}

export const SESSION_CHIP_VARIANTS = {
  CANCELED: 'canceled',
  LESSON_CREDIT: 'lessonCredit',
  PAID: 'paid',
  UNPAID: 'unpaid',
}

// Can be used if only one status chip is being displayed.
export function sessionChipStatus({ isCanceled, isPaid, isLessonCredit }) {
  if (isCanceled) return 'Canceled'
  if (isLessonCredit) return 'Credit Redeemed'
  return isPaid ? 'Paid' : 'Unpaid'
}

export function sessionChipVariant({ isCanceled, isPaid, isLessonCredit }) {
  if (isCanceled) return SESSION_CHIP_VARIANTS.CANCELED
  if (isLessonCredit) return SESSION_CHIP_VARIANTS.LESSON_CREDIT
  if (isPaid) return SESSION_CHIP_VARIANTS.PAID
  return SESSION_CHIP_VARIANTS.UNPAID
}
